import { Injectable } from '@angular/core';

import packageInfo from '../../../../package.json';

import { ConfigurationService } from './configuration.service';

export enum VersionChange {
    MAJOR = 1,
    MINOR = 2,
    PATCH = 3,
    PRE_RELEASE = 4,
    BUILD = 5,
    NO_CHANGE = 6,
}

@Injectable({
    providedIn: 'root',
})
export class VersionService {
    version: string;

    constructor(private configurationService: ConfigurationService) {
        this.version = packageInfo.version;
    }

    getAppVersion(): string {
        return this.version;
    }
    getVersionChange(newVersion: string): VersionChange {
        const versionChange = [
            VersionChange.MAJOR,
            VersionChange.MINOR,
            VersionChange.PATCH,
            VersionChange.PRE_RELEASE,
            VersionChange.BUILD,
        ];

        const previousVersionParts = this.version.split('.');
        const previousVersion = previousVersionParts.map((x) => x.replace(/\D/g, ''));
        const newVersionParts = newVersion.split('.');
        const nextVersion = newVersionParts.map((x) => x.replace(/\D/g, ''));

        while (previousVersion.length < nextVersion.length) {
            previousVersion.push('0');
        }
        while (nextVersion.length < previousVersion.length) {
            nextVersion.push('0');
        }

        for (let i = 0; i < previousVersion.length; ++i) {
            if (previousVersion[i] === nextVersion[i]) {
                continue;
            } else {
                return versionChange[i];
            }
        }

        return VersionChange.NO_CHANGE;
    }

    listenToVersionChanges(versionChange: VersionChange, action: () => void): void {
        this.configurationService.getConfiguration('dashboard').subscribe((res) => {
            if (res && res.version) {
                const currentVersionChange = this.getVersionChange(res.version);
                this.version = res.version;

                if (currentVersionChange <= versionChange) {
                    action();
                }
            }
        });
    }
}
